import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77282065")

_pushScopeId("data-v-77282065")
const _hoisted_1 = { class: "card" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_TenantDetail = _resolveComponent("TenantDetail")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_ProductTypes = _resolveComponent("ProductTypes")
  const _component_TabView = _resolveComponent("TabView")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-m-0" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.tenant.TENANT_NAME), 1)
      ]),
      end: _withId(() => [
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.handleSubmit
        }, null, 8, ["disabled", "onClick"]), [
          [
            _directive_tooltip,
            _ctx.$t('common.save'),
            void 0,
            { bottom: true }
          ]
        ]),
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTemplateConfirm
        }, null, 8, ["onClick"]), [
          [
            _directive_tooltip,
            _ctx.$t('common.close'),
            void 0,
            { bottom: true }
          ]
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_TabView, {
        class: "tabview-custom",
        "data-test": "tab-view"
      }, {
        default: _withId(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withId(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.tenantManagement.detail.title')), 1)
            ]),
            default: _withId(() => [
              _createVNode(_component_TenantDetail, {
                "selected-tenant": _ctx.tenant,
                "list-of-themes": _ctx.listOfThemes,
                onFieldChanged: _ctx.onFieldChange
              }, null, 8, ["selected-tenant", "list-of-themes", "onFieldChanged"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withId(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.tenantManagement.productTypes.title')), 1)
            ]),
            default: _withId(() => [
              _createVNode(_component_ProductTypes, {
                title: _ctx.$t('managers.tenantManagement.productTypes.title'),
                "data-list": _ctx.listOfProductTypes,
                "selected-data": _ctx.listOfSelectedProducts,
                onChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSelectedProducts($event)))
              }, null, 8, ["title", "data-list", "selected-data"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withId(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.tenantManagement.dataSource.title')), 1)
            ]),
            default: _withId(() => [
              _createVNode(_component_ProductTypes, {
                title: _ctx.$t('managers.tenantManagement.dataSource.title'),
                "data-list": _ctx.listOfDataSources,
                "selected-data": _ctx.listOfSelectedDataSources,
                onChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSelectedDataSources($event)))
              }, null, 8, ["title", "data-list", "selected-data"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
})